/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Legal_Reliability_IndicativeInputs */

const fr_legal_reliability_indicative = /** @type {(inputs: Legal_Reliability_IndicativeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bien que les données soient considérées comme fiables pour la majorité des réseaux, elles sont fournies à titre indicatif uniquement.`)
};

const en_legal_reliability_indicative = /** @type {(inputs: Legal_Reliability_IndicativeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Although the data is considered reliable for most networks, it is provided for information purposes only.`)
};

/**
* | output |
* | --- |
* | "Although the data is considered reliable for most networks, it is provided for information purposes only." |
*
* @param {Legal_Reliability_IndicativeInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const legal_reliability_indicative = /** @type {((inputs?: Legal_Reliability_IndicativeInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Legal_Reliability_IndicativeInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_legal_reliability_indicative(inputs)
	return en_legal_reliability_indicative(inputs)
});